var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4992 5.5262C38.4742 4.5012 36.6992 5.2012 36.6992 6.6262V15.3512C36.6992 19.0012 39.7992 22.0262 43.5742 22.0262C45.9492 22.0512 49.2492 22.0512 52.0742 22.0512C53.4992 22.0512 54.2492 20.3762 53.2492 19.3762C49.6492 15.7512 43.1992 9.2262 39.4992 5.5262Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 25.475H44.025C38.1 25.475 33.275 20.65 33.275 14.725V7.5C33.275 6.125 32.15 5 30.775 5H20.175C12.475 5 6.25 10 6.25 18.925V41.075C6.25 50 12.475 55 20.175 55H39.825C47.525 55 53.75 50 53.75 41.075V27.975C53.75 26.6 52.625 25.475 51.25 25.475ZM28.75 44.375H18.75C17.725 44.375 16.875 43.525 16.875 42.5C16.875 41.475 17.725 40.625 18.75 40.625H28.75C29.775 40.625 30.625 41.475 30.625 42.5C30.625 43.525 29.775 44.375 28.75 44.375ZM33.75 34.375H18.75C17.725 34.375 16.875 33.525 16.875 32.5C16.875 31.475 17.725 30.625 18.75 30.625H33.75C34.775 30.625 35.625 31.475 35.625 32.5C35.625 33.525 34.775 34.375 33.75 34.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/Document-text.4aa9fa46b5c3e56fd6766c8568f0a3da.svg";
export { ForwardRef as ReactComponent };